import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal, scrollToId, openCalendly } from "./utils";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" id="final-cta" className="relative overflow-hidden bg-brand-black py-28 md:py-36">
      <div className="grain-overlay pointer-events-none absolute inset-0 opacity-[0.05]" />
      {/* gold upward flow lines */}
      <svg className="pointer-events-none absolute inset-0 h-full w-full opacity-50" viewBox="0 0 1200 600" preserveAspectRatio="xMidYMax slice" fill="none">
        <defs>
          <linearGradient id="ctaFlow" x1="0" y1="600" x2="0" y2="0" gradientUnits="userSpaceOnUse">
            <stop stopColor="#C89A3D" stopOpacity="0" />
            <stop offset="1" stopColor="#C89A3D" stopOpacity="0.45" />
          </linearGradient>
        </defs>
        {[150, 380, 620, 850, 1080].map((x, i) => (
          <path
            key={x}
            d={`M${x} 600 C ${x - 60} 420, ${x + 80} 320, ${x} 120 L ${x} 60`}
            stroke="url(#ctaFlow)"
            strokeWidth="1.5"
            style={{ opacity: 0.4 + (i % 2) * 0.3 }}
          />
        ))}
      </svg>
      <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 -bottom-24 h-64 w-[700px] rounded-full bg-brand-gold/15 blur-[120px]" />

      <div className="relative max-w-[1000px] mx-auto px-6 md:px-12 text-center">
        <Reveal><Eyebrow className="justify-center">Your Next Opportunity May Already Be Inside Your Business</Eyebrow></Reveal>
        <Reveal delay={1}>
          <h2 className="mt-7 font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight text-white leading-[1.06]">
            Stop Guessing Where Revenue Is Going. <span className="gold-text">Start Seeing What to Fix.</span>
          </h2>
        </Reveal>
        <Reveal delay={2}>
          <p className="mt-7 mx-auto max-w-2xl font-sans text-base md:text-lg leading-relaxed text-white/60">
            Book a free Revenue Opportunity Call to explore where leads, quotes, past customers, follow-up, and growth
            opportunities may be slipping through the cracks.
          </p>
        </Reveal>
        <Reveal delay={3}>
          <div className="mt-10 flex flex-col items-center gap-6">
            <button
              data-testid="final-book-call"
              onClick={openCalendly}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-br from-brand-gold to-brand-gold-deep text-white px-9 py-4 font-sans text-sm font-semibold tracking-wide shadow-luxe-gold transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_30px_90px_-18px_rgba(200,154,61,0.6)]"
            >
              Book a Free Revenue Opportunity Call
              <ArrowRight className="h-4 w-4" />
            </button>
            <p className="font-sans text-sm text-white/45">
              Already invited by Apex Flow?{" "}
              <a
                href="#final-cta"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("final-cta");
                }}
                data-testid="final-portal-link"
                className="font-medium text-brand-gold hover:text-white transition-colors inline-flex items-center gap-1"
              >
                Access Your Assessment Portal <ArrowRight className="h-3.5 w-3.5" />
              </a>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
